<script setup lang="ts">
import { Inbox } from 'lucide-vue-next'

defineProps<{
    title: string
    subtitle?: string
}>()
</script>

<template>
    <div class="text-center p-8">
        <div class="max-w-[580px] mx-auto">
            <div class="inline-flex w-12 h-12 rounded-full bg-gray-100 items-center justify-center mb-4 text-gray-400">
                <slot name="icon"><Inbox class="w-6 h-6" /></slot>
            </div>
            <div class="text-base font-semibold text-ink mb-2">{{ title }}</div>
            <div v-if="subtitle" class="text-xs text-gray-500 mb-3">{{ subtitle }}</div>
            <div class="mt-3 inline-flex justify-center">
                <slot name="cta" />
            </div>
        </div>
    </div>
</template>
